/* /pages/exclusive-deals (28 Oct 2026): the sticky deal photo follows the row in the middle of the screen, as on
   thepetlabco.com/pages/app. Desktop only; on phone each row carries its own photo. */
(function () {
  'use strict';
  var box = document.querySelector('[data-oc3ed-deals]');
  if (!box) return;
  var rows = [].slice.call(box.querySelectorAll('[data-oc3ed-row]'));
  var imgs = [].slice.call(box.querySelectorAll('[data-oc3ed-img]'));
  if (!rows.length || !imgs.length) return;
  var current = '1';
  function show(n) {
    if (n === current) return;
    current = n;
    imgs.forEach(function (img) {
      var on = img.getAttribute('data-oc3ed-img') === n;
      if (on && img.loading === 'lazy') img.loading = 'eager';
      img.classList.toggle('on', on);
    });
  }
  // Warm the other photos once the section is near, so the swap never shows an empty frame.
  if ('IntersectionObserver' in window) {
    var warm = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        imgs.forEach(function (img) { img.loading = 'eager'; });
        warm.disconnect();
      }
    }, { rootMargin: '600px 0px' });
    warm.observe(box);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) show(e.target.getAttribute('data-oc3ed-row'));
      });
    }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
    rows.forEach(function (row) { io.observe(row); });
  }
})();
